import { useTranslation } from 'react-i18next';
import {
  VideoContainer,
  VideoDescription,
  VideoDiv,
  VideoErrorMsg,
  VideoIframe,
} from './styled/Video.styled';

import registerNamespace from './locales/localesVideo';

const namespace = registerNamespace('src/components/Header/Video.tsx');

interface VideoProps {
  link: string;
  description: string;
}

const videoDefaultPropLink: string = '';
const videoDefaultPropDescription: string = '';

const Video = ({
  link = videoDefaultPropLink,
  description = videoDefaultPropDescription,
}: VideoProps) => {
  const { t } = useTranslation(namespace);
  const getYoutubeEmbedUrl = (url: string) => {
    if (!url || typeof url !== 'string') {
      return null;
    }
    try {
      const normalizedUrl = /^https?:\/\//i.test(url)
        ? url
        : `https://${url}`;

      const parsedUrl = new URL(normalizedUrl);

      let videoId = null;

      if (parsedUrl.hostname === 'www.youtube.com' || parsedUrl.hostname === 'youtube.com') {
        videoId = parsedUrl.searchParams.get('v');
      }

      if (parsedUrl.hostname === 'youtu.be') {
        videoId = parsedUrl.pathname.substring(1);
      }

      if (!videoId) {
        return null;
      }
      return `https://www.youtube.com/embed/${videoId}`;
    } catch (error) {
      console.log('Erro ao processar URL do vídeo: ', String(error));
      return null;
    }
  };

  const newLink = getYoutubeEmbedUrl(link);

  return (
    <VideoDiv>
      <VideoContainer>
        {newLink ? (
          <VideoIframe
            width="100%"
            height="100%"
            src={`${newLink}?autoplay=1`}
            title="YouTube video player"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        ) : (
          <VideoErrorMsg>
            {t('linkNotValid')}
          </VideoErrorMsg>
        )}
      </VideoContainer>
      {description?.length > 0 && (
        <VideoDescription>
          {description}
        </VideoDescription>
      )}
    </VideoDiv>
  );
};

export default Video;
